import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextField from '../TextField';
import PickList from '../PickList';
import { row, column } from '../../globals';
import { checkRequiredField, validateEmail, validatePhone } from '../../services/validation';


const ContactInformationStyled = styled.div`
    padding: 0 10px;
`;

const TitleStyled = styled.div`
    padding: 60px 0 5px 20px;
    font-size: 25px;
    color: #3E2723;
    letter-spacing: 0;
    font-family: IntroRegular;
    display: ${props => props.display ? props.display : 'inherit'};
`;

const Row = styled.div`
  ${row(0)};
`;

const StyledField = styled.div`
    ${column(12, 'xs')};
    ${column(6, 'md', 20)};
`;

const contactTimes = (props) => {
    const availabilityList = [
        'Morning',
        'Afternoon',
        'Evening'];

    return availabilityList.map(time => props.getLocalizedText(time, time));
};

class ContactInformation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: props.firstName,
            lastName: props.lastName,
            contactPreference: props.contactPreference,
            emailId: props.emailId,
            phone: props.phone,
            preferredContactTime: props.preferredContactTime
        };
        this.localizeContactPreferences(props);
    }

    contactPreferences = {
        DoNotContactMe: 'Do not contact me back',
        ContactMeViaPhone: 'Contact me back via phone',
        ContactMeViaEmail: 'Contact me back via email'

    };

    localizeContactPreferences = () => {
        Object.keys(this.contactPreferences)
            .forEach((preference) => {
                this.contactPreferences[preference] =
                    this.props.getLocalizedText(preference, this.contactPreferences[preference]);
            });
    };

    contactPreferencesList = () => Object.keys(this.contactPreferences)
            .map(preference => this.contactPreferences[preference]);

    updateContactInfo = (val) => {
        this.setState(val, this.props.handleUpdate(val));
    };

    updateEmail = (email) => {
        const componentState = { emailId: email };

        const formState = { emailId: email, errors: this.props.errors };
        formState.errors.emailId = false;

        this.setState(componentState, this.props.handleUpdate(formState));
    };

    changeContactPreference = (value) => {
        if (value !== this.state.contactPreference) {
            const errors = this.props.errors;
            errors.contactPreference = false;
            errors.emailId = false;
            errors.phone = false;
            const contactInfo = {
                contactPreference: value,
                errors,
                emailId: '',
                phone: '',
                preferredContactTime: ''
            };
            this.updateContactInfo(contactInfo);
        }
    };

    validateName = (fieldName) => {
        let error;
        if (fieldName.indexOf('phone') > -1) {
            error = validatePhone(this.state[fieldName]);
        } else {
            // eslint-disable-next-line max-len
            const evaluateForError = checkRequiredField(this.state[fieldName]); // returns 'Required'||undefined
            error = (evaluateForError) ? this.props.getLocalizedText(evaluateForError, 'required') : undefined;
        }

        if (error) {
            // const componentState = {};
            // componentState[fieldName] = '';

            const formState = { errors: this.props.errors };
            formState.errors[fieldName] = true;
            formState[fieldName] = '';

            // this.setState(componentState, this.props.handleUpdate(formState));
            this.props.handleUpdate(formState);
        }
    };

    emailValidationHandler = () => {
        const error = validateEmail(this.state.emailId);

        if (error) {
            const componentState = {};
            const formState = { errors: this.props.errors };

            if (!this.state.emailId.trim()) {
                componentState.emailId = '';
                formState.emailId = '';
            }

            formState.errors.emailId = true;

            this.setState(componentState, this.props.handleUpdate(formState));
        }
    };

    render() {
        return (
            <ContactInformationStyled>
                <TitleStyled display={this.props.showTitle ? 'inherit' : 'none'}>
                    {this.props.getLocalizedText('ContactInformation', 'Contact Information')}
                </TitleStyled>
                <Row>
                    <StyledField>
                        <TextField label={this.props.getLocalizedText('FirstName', 'First Name')}
                                   required={true}
                                   value={this.state.firstName}
                                   onChangeHandler={ (value) => {
                                       const errors = this.props.errors;
                                       errors.firstName = false;

                                       this.updateContactInfo({ firstName: value, errors });
                                   }}
                                   validate={() => { this.validateName('firstName'); }}
                                   error={this.props.errors.firstName ? this.props.getLocalizedText('Required', 'required') : ''}
                        />
                    </StyledField>
                    <StyledField>
                        <TextField label={this.props.getLocalizedText('LastName', 'Last Name')}
                                   required={true}
                                   value={this.state.lastName}
                                   onChangeHandler={(value) => {
                                       const errors = this.props.errors;
                                       errors.lastName = false;

                                       this.updateContactInfo({ lastName: value, errors });
                                   }}
                                   validate={() => { this.validateName('lastName'); }}
                                   error={this.props.errors.lastName ? this.props.getLocalizedText('Required', 'required') : ''}
                        />
                    </StyledField>
                </Row>
                <Row>
                    <StyledField>
                        <PickList instanceId={'select_contact_preference'}
                                  label={this.props.getLocalizedText('ContactPreference', 'Contact Preference')}
                                  value={this.state.contactPreference}
                                  options={this.contactPreferencesList()}
                                  handleChange={this.changeContactPreference}
                                  error={this.props.errors.contactPreference}
                                  getLocalizedText={this.props.getLocalizedText} />
                    </StyledField>
                </Row>

                { this.makeEmailField() }

                { this.makePhoneNumberFields() }

            </ContactInformationStyled>
        );
    }

    makeEmailField() {
        if (this.state.contactPreference === this.contactPreferences.ContactMeViaEmail) {
            return (
                <Row>
                    <StyledField>
                        <TextField label={this.props.getLocalizedText('EmailAddress', 'Email Address')}
                                   required={true}
                                   value={this.state.emailId}
                                   type="email"
                                   onChangeHandler={this.updateEmail}
                                   validate={this.emailValidationHandler}
                                   error={this.props.errors.emailId ?
                                       this.props.getLocalizedText(validateEmail(this.state.emailId), 'Invalid Email Address') :
                                       ''} />
                    </StyledField>
                </Row>
            );
        }
        return null;
    }

    makePhoneNumberFields() {
        if (this.state.contactPreference === this.contactPreferences.ContactMeViaPhone) {
            return (
                <Row>
                    <StyledField>
                        <TextField label={this.props.getLocalizedText('PhoneNumber', 'Phone Number')}
                                   required={true}
                                   value={this.state.phone}
                                   type="tel"
                                   onChangeHandler={(value) => {
                                       const errors = this.props.errors;
                                       errors.phone = false;

                                       this.updateContactInfo({ phone: value, errors });
                                   }
                                   }
                                   validate={() => { this.validateName('phone'); }}
                                   error={ this.props.errors.phone ?
                                       this.props.getLocalizedText(validatePhone(this.state.phone), 'Invalid Phone Number') :
                                       ''} />
                    </StyledField>
                    <StyledField>
                        <PickList instanceId={'contact-time'}
                                  label={this.props.getLocalizedText('BestContactTime', 'Best Contact Time')}
                                  options={ contactTimes(this.props) }
                                  value={this.state.preferredContactTime}
                                  handleChange={(value) => {
                                      this.updateContactInfo({ preferredContactTime: value }); 
                                  }
                                  }/>
                    </StyledField>
                </Row>
            );
        }
        return null;
    }

}

ContactInformation.propTypes = {
    showTitle: PropTypes.bool,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    contactPreference: PropTypes.string,
    emailId: PropTypes.string,
    phone: PropTypes.string,
    preferredContactTime: PropTypes.string,
    handleUpdate: PropTypes.func.isRequired,
    getLocalizedText: PropTypes.func.isRequired,
    errors: PropTypes.object,
    locale: PropTypes.shape({
        country: PropTypes.string,
        language: PropTypes.string,
        localeCode: PropTypes.string
    })
};

ContactInformation.defaultProps = {
    showTitle: false,
    firstName: '',
    lastName: '',
    contactPreference: '',
    emailId: '',
    phone: '',
    preferredContactTime: '',
    handleUpdate: () => {},
    getLocalizedText: (key, defaultValue) => defaultValue,
    errors: {},
    locale: {
        country: 'US',
        language: 'en',
        localeCode: 'en_US'
    }
};

export default ContactInformation;



// WEBPACK FOOTER //
// ./src/components/ContactInformation/index.js